export default __webpack_public_path__ + "static/media/mlb-player.af41cff9.png";